import { ColumnDetails } from '../../../grid/types/common';
import { Column, ColumnKeys, PackageData } from '../types';
import { html } from 'lit';
import { TemplateResult } from 'lit';
import { NOT_EDITABLE_TYPES } from '../../packagesApp/constants';

export function renderPackageName(
  dispatchClickEventFn: (packageData: PackageData) => void,
  rowData,
  columnDetails: ColumnDetails<Column, ColumnKeys>
): TemplateResult {
  let packageName = rowData.item[columnDetails.key];
  let classForStyle = 'accent cell-label';
  let styleForName = 'cursor: pointer';
  if (NOT_EDITABLE_TYPES.indexOf(rowData.item['type']) > -1) {
    classForStyle = 'cell-label';
    styleForName = '';
  }
  const mappedDefaultName = this.stringsTranslator.getTranslatedNamesInstallationPackages(
    rowData.item[columnDetails.key],
    rowData.item['company']['name'],
    this.dependencies.userHasRight('manageCompanies')
  );

  if (rowData.item['default'] && mappedDefaultName) {
    packageName = mappedDefaultName;
  }

  return html`<span class=${classForStyle} style=${styleForName} @click="${() => dispatchClickEventFn(rowData.item)}"
    >${packageName}</span
  >`;
}

export function renderPackageTypeName(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>): TemplateResult {
  const packageType = rowData.item[columnDetails.key];
  const packageTypesNames: string[] = this.getPackageTypesNames();

  return html`<span class="cell-label">${packageTypesNames[packageType]}</span>`;
}

export function renderLanguageName(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>): TemplateResult {
  const languages = this.dependencies.getLanguages();
  const languageId = rowData.item[columnDetails.key];
  let language = '';

  for (let i = 0; i < languages.length; i++) {
    if (languages[i].id === languageId) {
      language = languages[i].title;
      break;
    }
  }

  language = this.handleStatusNA(language);

  return html`<span class="cell-label">${language}</span>`;
}

export function renderDescription(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>): TemplateResult {
  let description = rowData.item[columnDetails.key];
  description = this.handleStatusNA(description);

  return html`<span class="cell-label">${description}</span>`;
}
